const matchText = (needle: string, haystack: string) => {
    return String(haystack)
        .trim()
        .toLowerCase()
        .includes(String(needle).toLowerCase());
};

export default matchText;
